module.exports = __webpack_public_path__ + "static/media/enterprise-college-02.62c5086a.jpg";